/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1CashBalanceEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_PORTFOLIO_V1_CASH_BALANCE_EVENT_ENTITY_NAME = 'ixc.portfolio.v1.CashBalanceEvent';
export const ixcPortfolioV1CashBalanceEventEntity = new schema.Entity<IxcPortfolioV1CashBalanceEvent>(IXC_PORTFOLIO_V1_CASH_BALANCE_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        config: new schema.Object({
            asset: ixcAssetsV1AssetStateEntity
        })
    })
}, { idAttribute: (entity: IxcPortfolioV1CashBalanceEvent) => `${entity.metadata?.eventId}` });

